export const CHANNELS = Object.freeze({
    ALL: 'ALL',
    RETAIL: 'RETAIL',
    FBA: 'FBA',
    MFN: 'MFN'
});


// WEBPACK FOOTER //
// ./src/constants/channels.jsx